<script setup lang="ts">
import { usePromotionStore } from "@stores/promotion";

const promotionStore = usePromotionStore();

const runtimeConfig = useRuntimeConfig();
const url = runtimeConfig.public.API_URL + "/storage/";

const config = useRuntimeConfig();
const CFIMAGE_URL = config.public.CLOUDFLARE_HOST_URL;

const getImageUrl = (data) => {
  return data.image_cf 
          ? CFIMAGE_URL + data.image_cf + '/banDesktop' 
          : data.image.startsWith('http') ? data.image : `/storage${data.image}`;
}

</script>

<template>
  <div 
    v-if="promotionStore.state.promotions.length"
    class="mx-auto max-w-[1105px] select-none space-y-6 p-5">
    <header>
      <h2 class="text-xl font-extrabold">Promoções</h2>
    </header>

    <section class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      <nuxt-link
        v-for="promotion in promotionStore.state.promotions"
        :to="`/promotions/${promotion.slug}`"
        class="h-64 overflow-hidden rounded-md bg-cover scale-100 hover:scale-105 transition-all transform duration-[0.4s] ease-in"
        :style="`background-image: url(${getImageUrl(promotion)})`"
        :key="promotion"
      >
        <div
          class="flex h-full w-full items-end bg-promotion-header p-4 xs:p-6"
        >
          <div class="max-w-[80%]">
            <div class="mb-2 font-bold md:text-2xl">{{ promotion.name }}</div>
            <p class="max-w-[70%] text-sm text-gray-500 line-clamp-3 sm:line-clamp-2">
              {{ promotion.description }}
            </p>

            <BaseButton variant="primary" class="mt-6 md:hidden">
              Participar
            </BaseButton>

            <BaseButton
              variant="primary"
              size="lg"
              class="mt-6 hidden md:inline-flex"
            >
              Participar
            </BaseButton>
          </div>
        </div>
      </nuxt-link>
    </section>
  </div>
</template>
